"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SideBarContainer = exports.ACTIVE_FILTER_TYPES = void 0;
const react_1 = __importStar(require("react"));
const ramda_1 = require("ramda");
const react_redux_1 = require("react-redux");
const side_bar_component_1 = require("./side-bar.component");
const hooks_1 = require("../../../hooks");
const localization_1 = require("../../../localization");
const hooks_2 = require("../../hooks");
const creators_1 = require("../../../store/actions/creators");
const selectors_1 = require("../../../store/selectors");
const State = __importStar(require("../../../store/state"));
const utils_1 = require("../../../utils");
exports.ACTIVE_FILTER_TYPES = [
    State.ProductFilterActiveTypes.All,
    State.ProductFilterActiveTypes.Active,
    State.ProductFilterActiveTypes.Inactive,
];
const SideBarContainer = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const token = (0, hooks_1.useToken)();
    const { resetAllFilters } = (0, hooks_2.useResetAllFilters)();
    const { classTotals, categoryTotals, attributeTotals, isLoading: isProductCountsLoading, } = (0, hooks_2.useProductCounts)();
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const selectedOrganizationsIds = (0, selectors_1.useSelectedOrganizationsIdsSelector)();
    const activeFilter = (0, selectors_1.useProductsFilterActive)();
    const resultsFilter = (0, selectors_1.useProductsFilterOperator)();
    const loadRefinements = (0, hooks_2.useRefinements)();
    const { isLoading: isCategoriesLoading, loadCategories } = (0, hooks_2.useLoadCategories)();
    const organizations = (0, selectors_1.useOrganizationsSelector)();
    const availableRefinementsFilter = (0, selectors_1.useRefinementsFilterSelector)();
    const { performOrganizationSelectionSideEffects } = (0, utils_1.useSelectOrganizationSideEffects)();
    const handleChangeFilter = (0, react_1.useCallback)((newValue) => {
        dispatch((0, creators_1.productsSetFilterActive)(newValue));
    }, [dispatch]);
    const handleSetOrganization = (0, react_1.useCallback)((name) => {
        if (name === t({ key: State.ORGANIZATIONS_DEFAULT_OPTIONS.NONE.name })) {
            dispatch((0, creators_1.organizationsSetIds)([]));
        }
        else {
            dispatch((0, creators_1.organizationsSetIds)([organizations.find((item) => name === item.name).id]));
        }
        performOrganizationSelectionSideEffects();
    }, [organizations]);
    const selectedOrganization = (0, react_1.useMemo)(() => {
        if (!selectedOrganizationsIds.length) {
            return [t({ key: State.ORGANIZATIONS_DEFAULT_OPTIONS.NONE.name })];
        }
        if ((selectedOrganizationsIds === null || selectedOrganizationsIds === void 0 ? void 0 : selectedOrganizationsIds.length) && organizations.length) {
            return selectedOrganizationsIds.map((id) => organizations.find((organizationData) => id === organizationData.id).name);
        }
        return [];
    }, [t, organizations, selectedOrganizationsIds]);
    const handleRefinementsFilter = (0, react_1.useCallback)((newValue) => {
        dispatch((0, creators_1.refinementsSetFilter)(newValue));
    }, [dispatch]);
    const handleChangeFilterOperator = (0, react_1.useCallback)((newValue) => {
        dispatch((0, creators_1.productsSetFilterOperator)(newValue));
    }, [dispatch]);
    const isOrganizationSelected = !!selectedOrganizationsIds.length;
    (0, react_1.useEffect)(() => {
        if (!(0, ramda_1.isEmpty)(selectedOrganizationsIds) && token) {
            void loadRefinements();
            void loadCategories();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedOrganizationsIds, token]);
    return (react_1.default.createElement(side_bar_component_1.SideBarComponent, { selectedOrganization: selectedOrganization, activeFilter: activeFilter, availableRefinementsFilter: availableRefinementsFilter, resultsFilter: resultsFilter, organizations: organizations, classTotals: classTotals, categoryTotals: categoryTotals, attributeTotals: attributeTotals, isProductCountsLoading: isProductCountsLoading, isOrganizationSelected: isOrganizationSelected, isCategoriesLoading: isCategoriesLoading, onSetOrganization: handleSetOrganization, onChangeFilter: handleChangeFilter, onRefinementsFilter: handleRefinementsFilter, onChangeFilterOperator: handleChangeFilterOperator, onResetAllFilters: resetAllFilters }));
};
exports.SideBarContainer = SideBarContainer;
exports.default = exports.SideBarContainer;
